import { SchemasRoot } from '../constants.js';

export enum MirrorSchemaId {
  LATEST = `${SchemasRoot}/publications/mirror/1.0.0.json`,
}
